import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import React, { Component } from 'react';
import { TeamsList } from './TeamsList';
import { fetchTeams } from '../redux/teams-list/actions';
import { getTeamsListState } from '../redux/teams-list/selectors';
import {
    addPermissionToTeam,
    deletePermissionFromTeam
} from '../redux/permissions/actions';

class TeamsListContainer extends Component {
    componentDidMount() {
        this.props.fetchTeams && this.props.fetchTeams();
    }

    render() {
        const { teams, loaded } = this.props;

        return (
            <TeamsList
                teams={teams}
                loaded={loaded}
                addPermission={this.props.addPermissionToTeam}
                removePermission={this.props.deletePermissionFromTeam}
            />
        );
    }
}

const mapStateToProps = state => {
    const { loaded, loading, error, data } = getTeamsListState(state);

    return {
        teams: data,
        loaded,
        loading,
        error
    };
};
const mapDispatchToProps = dispatch => ({
    fetchTeams: () => dispatch(fetchTeams()),
    addPermissionToTeam: (teamId, permission) =>
        dispatch(addPermissionToTeam({ teamId, permission })),
    deletePermissionFromTeam: (teamId, permission) =>
        dispatch(deletePermissionFromTeam({ teamId, permission }))
});

export default withRouter(
    connect(mapStateToProps, mapDispatchToProps)(TeamsListContainer)
);
